import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { childFolderType } from "../../redux/fileManager/fileManagerTypes";
import { returnInputFieldLength } from "../../utils/commonFunctions";

type finalFolderDataType = {
  folder_name: string;
  folder_id: any;
};

type AppProps = {
  isOpen: boolean;
  currentFolder: childFolderType | null;
  toggleRenameFolderModal: () => void;
  handleRenameFolder: (data: any) => void;
};

const RenameFolderModal = ({
  isOpen,
  toggleRenameFolderModal,
  currentFolder,
  handleRenameFolder,
}: AppProps) => {
  let preFilledInputData = currentFolder?.name?.slice(0);
  const [folderName, setFolderName] = useState<string>(
    preFilledInputData ? preFilledInputData : ""
  );
  const [folderNameError, setFolderNameError] = useState<string>("");
  const [onCancel, setOnCancel] = useState(isOpen);
  const handleFolderNameChange = (e: any) => {
    setFolderName(e.target.value);

    if (folderNameError) {
      setFolderNameError("");
    }
  };

  const handleAddFolder = (e: any) => {
    e.preventDefault();
    if (!folderName.length) {
      setFolderNameError("Folder name is required!");
    } else {
      let finalData: finalFolderDataType = {
        folder_name: folderName.trim(),
        folder_id: currentFolder?.id,
      };

      handleRenameFolder(finalData);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={() => setOnCancel(true)}>
      <ModalHeader className="pt-4 pl-4">Rename Folder</ModalHeader>
      <ModalBody className="pl-4 pr-4">
        <div className="row"></div>
        <form>
          <div className="form-group mt-3">
            <div>
              <label
                htmlFor="foldername"
                className={folderName ? "active" : ""}
              >
                Enter Folder Name<span className="color-red">*</span>
              </label>
              <input
                type="text"
                className={`form-control ${
                  !!folderNameError ? "error-border" : null
                }`}
                name="text"
                value={folderName}
                autoFocus
                onChange={(e) => handleFolderNameChange(e)}
                maxLength={60}
                onKeyPress={(e: any) =>
                  e.key === "Enter" ? handleAddFolder(e) : null
                }
              />
              {!!folderNameError && (
                <small className="text-danger">{folderNameError}</small>
              )}
            </div>
            <span className="input-length">
              {returnInputFieldLength(folderName?.length, 60)}
            </span>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <span
          className="pointer"
          onClick={() => {
            toggleRenameFolderModal();
            setOnCancel(!onCancel);
          }}
        >
          Cancel
        </span>
        <Button color="primary ml-3" onClick={(e: any) => handleAddFolder(e)}>
          {" "}
          Rename Folder
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RenameFolderModal;
